module.exports = __webpack_public_path__ + "static/media/mail.5bc3efc9.svg";